export const processesHeaders = {
  id: "process.id",
  title: "process.title",
  records: "process.records",
  status: "process.statusLabel",
  userName: "process.userName",
  createdAt: "process.createdAt",
} as const;

export type ProcessesHeaderKeys = keyof typeof processesHeaders;
